import { FormControl, FormHelperText, OutlinedInput, Typography } from '@mui/material'
import { styled, useTheme } from '@mui/material/styles'
import { Box } from '@mui/material'
import React, { useMemo } from 'react'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'

const shouldNotForwardProp = ["bgwhite", "InputLabelProps"];

const FormInput = styled(OutlinedInput, {
  shouldForwardProp: (props) => !shouldNotForwardProp.includes(props),
})(({ theme, ...rest }) => ({
  height: 50,
  borderRadius: 5,
  position: 'relative',
  fontSize: 14,
  fontWeight: 'lighter',
  width: '100%',
  color: theme.palette.color.darkBlue,
  // '&:disabled': {
  //   color: theme.palette.color.darkBlue50,
  // },
  padding: '13px 15px',
  border: `1px solid transparent`,
  borderColor: rest.error
    ? theme.palette.color.negative
    : rest.borderLess
      ? 'transparent'
      : theme.palette.color.darkBlue20,

  backgroundColor: rest.error ? 'rgba(254, 67, 52, 0.05)' : rest.disabled ? '#f4f4f7' : theme.palette.background.white,
  // '&:hover': {
  //   borderColor: rest.error ? theme.palette.color.negative : theme.palette.color.blue,
  // },
  '&:focus-within': {
    border: rest.error ? '1px solid #D14343' : '1px solid #0a78cd',
    backgroundColor: rest.error ? 'rgba(254, 67, 52, 0.05)' : rest.disabled ? '#f4f4f7' : rest.bgwhite ? '#f2f8fc' : theme.palette.background.white,
    caretColor: rest.bgwhite ? '#25245f' : '#0a78cd',
  },
  input: {
    height: '22px',
    padding: 0,
    backgroundColor: 'transparent',
  },

  fieldset: {
    display: 'none',
  },
}))

const SelectIcon = styled(Box)(({ theme }) => ({
  background: theme.palette.color.darkBlue5,
  position: 'absolute',
  right: 0,
  marginRight: '15px',
  marginTop: '38px',
  borderRadius: '4px',
  '&:hover': {
    background: theme.palette.color.darkBlue10,
  },
}))

const labelStyle ={
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '12px',
  color: '#D14343',
  lineHeight: '16px'
}

const TextField = props => {
  const {
    placeholder,
    helperText,
    error,
    label,
    value,
    fullWidth,
    name,
    type,
    disabled,
    autoComplete,
    InputProps,
    ref,
    autoFocus,
    onChange,
    onBlur,
    onFocus,
    externalClasses,
    onKeyPress,
    onClickSelect,
    // disableOnlyInput = false,
    isSelect = false,
    required,
    bgwhite,
    setFieldTouched,
    ...rest
  } = props
  const id = useMemo(() => Math.random().toString(32).substr(3), [])
  const theme = useTheme()

  return (
    <FormControl fullWidth={fullWidth}>
      {label ? (
        <Typography
          component={'label'}
          color={'primary'}
          htmlFor={id}
          sx={{
            marginBottom: '4px',
            fontSize: '14px',
            lineHeight: '21px',
            fontWeight: 500,
          }}
        >
          {label}
          {required ? <span className="text-danger">&nbsp;*</span> : null}
        </Typography>
      ) : null}

      <FormInput
        // heyProps={true}
        required={required}
        bgwhite={bgwhite}
        autoFocus={autoFocus}
        fullWidth={fullWidth}
        autoComplete={autoComplete}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        id={id}
        placeholder={placeholder}
        error={error}
        name={name}
        type={type}
        disabled={disabled}
        ref={ref}
        onKeyPress={onKeyPress}
        {...InputProps}
        {...rest}
      />
      {isSelect && (
        <SelectIcon onClick={onClickSelect} >
          <ArrowDropDownIcon sx={{ fontSize: '24px', color: theme.palette.color.darkBlue50 }} />
        </SelectIcon>
      )}
      {helperText && (
        <FormHelperText
          error={error}
          sx={{
            margin: 0,
            position: 'static',
            bottom: 0,
            color: '#66668F',
          }}
        >
          <Typography variant="caption" sx={labelStyle}>
            {helperText}
          </Typography>
        </FormHelperText>
      )}
    </FormControl>
  )
}

export default TextField
